import { render, staticRenderFns } from "./NewDownloadPage.vue?vue&type=template&id=b8982768&"
import script from "./NewDownloadPage.vue?vue&type=script&lang=js&"
export * from "./NewDownloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports